<template>
  <div>
    <label :for="selectName">{{selectLabel}}</label>
    <select
      :class="selectClassName"
      :name="selectName"
      @change="selectAndVerifyValue"
      @focus="$emit('focus')"
      v-model="verifiedSelectedOption"
    >
      <option :key="option" v-for="option in options" :value="option">{{ option }}</option>
    </select>
    <span v-if="!isValid">{{errorText}}</span>
  </div>
</template>

<script>
export default {
  props: {
    options: Array,
    selectValue: Function,
    selectName: String,
    selectLabel: String,
    isValid: Boolean,
    errorText: String,
    selectedOption: String,
    selectorSize: String,
  },
  data() {
    return {
      verifiedSelectedOption:
        (!this.selectedOption || this.selectedOption.length === 0 || this.selectedOption === "") 
          ? (this.options && this.options.length > 0 ? this.options[0] : "") 
          : this.selectedOption
    };
  },
  computed: {
    selectClassName: function() {
      return this.isValid ? "" : " error";
    }
  },
  methods: {
    selectAndVerifyValue: function(event) {
      const value = event.target.value;
      // Check if it's not the first option (placeholder) or empty
      if (value && this.options.indexOf(value) > 0) {
        this.selectValue(value);
      } else {
        this.selectValue("");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
label {
  display: block;
  margin-bottom: 6px;
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  line-height: 1.4;
}

select {
  display: block;
  padding: 11px 40px 11px 16px;
  height: 44px;
  font-size: 16px;
  font-weight: 500;
  width: 100%;
  border: 2px solid #e2e8f0;
  border-radius: 6px;
  background-color: #f8fafc;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #1a1a1a;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 8px center;
  
  option {
    padding: 8px;
    background-color: #fff;
  }
  
  &:hover {
    background-color: #f1f5f9;
    border-color: #cbd5e1;
  }
  
  &:focus {
    outline: none;
    border-color: #bd1f23;
    background-color: #fff;
    box-shadow: 0 0 0 1px rgba(189, 31, 35, 0.1);
  }
  
  &.error {
    border-color: #bd1f23;
    background-color: #fff;
    
    &:focus {
      border-color: #bd1f23;
      box-shadow: 0 0 0 1px rgba(189, 31, 35, 0.1);
    }
  }
}

span {
  display: block;
  margin: 6px 0 0 0;
  color: #bd1f23;
  font-size: 14px;
}
</style>


